<template>
  <v-data-table
    :headers="headers"
    :items="driedAbaloneCookingSheets"
    class="elevation-1"
    :loading="isLoading"
  >
    <template v-slot:top>
      <v-toolbar
        flat
      >
        <v-btn
          color="success"
          data-cy="DriedAbaloneCookingSheet-button-new"
          @click="$router.push({
            name: 'dried-abalone-cooking-sheet-EditDriedAbaloneCookingSheet'
          })"
        >
          <v-icon class="mr-2">
            {{ mdiPlus }}
          </v-icon>
          {{ $t('common.buttons.new') }}
        </v-btn>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <TableBasicButtons :editLink="{
          name: 'dried-abalone-cooking-sheet-EditDriedAbaloneCookingSheet',
          query: {id: item.id}
        }"
        @delete="remove(item)"
      />
    </template>
  </v-data-table>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { mdiPlus } from '@mdi/js';
import TableBasicButtons from '@codehq/aurora-app-core/src/components/TableBasicButtons.vue';
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'ListDriedAbaloneCookingSheet',
  module: 'DriedAbaloneCookingSheet',
  components: {
    TableBasicButtons,
  },
  mixins: [loading],
  data() {
    return {
      /**
      * Icons
      */
      mdiPlus,
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('driedAbaloneCookingSheets', ['driedAbaloneCookingSheets']),
    /**
    * Get table column headers
    */
    headers() {
      return [
        {
          text: this.$$t('farm'),
          value: 'farm',
        },
        {
          text: this.$$t('deliveryDate'),
          value: 'deliveryDate',
        },
        {
          text: this.$$t('drySizeRange'),
          value: 'drySizeRange',
        },
        {
          text: this.$$t('cookingDate'),
          value: 'cookingDate',
        },
        {
          text: this.$$t('liveWeight'),
          value: 'liveWeight',
        },
        {
          text: this.$$t('outOfSalt'),
          value: 'outOfSalt',
        },
        {
          text: this.$$t('afterSoaking'),
          value: 'afterSoaking',
        },
        {
          text: this.$$t('outOfBrine'),
          value: 'outOfBrine',
        },
        {
          text: this.$$t('afterScrubbing'),
          value: 'afterScrubbing',
        },
        {
          text: this.$$t('afterCooking'),
          value: 'afterCooking',
        },
        {
          text: this.$$t('underSizedWeight'),
          value: 'underSizedWeight',
        },
        {
          text: this.$$t('totalStringedWeight'),
          value: 'totalStringedWeight',
        },
        {
          text: '',
          value: 'actions',
        },
      ];
    },
  },
  async mounted() {
    this.isLoading = true;
    await this.LOAD_driedAbaloneCookingSheets();
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('driedAbaloneCookingSheets', ['LOAD_driedAbaloneCookingSheets', 'DELETE_driedAbaloneCookingSheet']),
    /** Delete DriedAbaloneCookingSheet from the collection
     */
    async remove(DriedAbaloneCookingSheet) {
      this.isLoading = true;
      await this.DELETE_DriedAbaloneCookingSheet(DriedAbaloneCookingSheet);
      this.isLoading = false;
    },
  },
};
</script>

<docs>
# DriedAbaloneCookingSheet example

'''js
<DriedAbaloneCookingSheet />
'''
</docs>
